import React from 'react';

import onelps from './api';
import { Config, ServerEnvironment } from './api/config';
import { getMockedConfig } from '../mockedSDKconfig';

import { removeBackslashes } from './helpers/string';
import { ENVIRONMENTS } from './constants/environments';
import { ChallengeConfig, OtherGamesType } from './api/config/types';
import { LoginHubConfig } from './types/concept-config';

onelps.init({ mode: ENVIRONMENT });

if (ENVIRONMENT === ENVIRONMENTS.DEVELOPMENT) {
	onelps.config = new Config(getMockedConfig());
}

export interface SdkParams {
	snippets: {
		optional: string[];
		mandatory: string[];
	};
	gameId: string;
	marketId: string;
	locale: string;
	country: string | undefined;
	isMonolingual: boolean;
	portalBarCSS: string | null;
	portalBarJS: string | null;
	portalBarHTML: string | null;
	cdnUrlPrefix: string;
	landingPageId: string;
	partnerPrefix: string;
	campaignId: string;
	bannerId: string;
	creativeId: string;
	publisherId: string;
	backendRequestEventId: string;
	nickname: string;
	forgotPw: {
		token: string | null;
		errorCode: string | null;
	};
	portalSsoError: {
		type: string | null;
		translationKey: string | null;
	};
	ssoConfirmationPath: string | null;
	singularPcn: string | null;
	singularDeepLink: string | null;
	isSingularForwardParams: boolean;
	operatingSystem: string;
	deviceType: string;
	isMobileRequest: boolean;
	isBot: boolean;
	isSpam: boolean;
	environment: ServerEnvironment;
	gameUrl?: string;
	lpsUrl?: string;
	otherGames: OtherGamesType;
	bigbeat?: string;
	tagline?: {
		show: boolean;
		translationKey?: string;
	};
	loginhub?: LoginHubConfig;
	challengeConfig?: ChallengeConfig
}

export const sdkParams = {
	snippets: {
		optional: onelps.config.getOptionalSnippets(),
		mandatory: onelps.config.getMandatorySnippets(),
	},
	gameId: onelps.config.getGameId(),
	marketId: onelps.config.getMarketId(),
	locale: onelps.config.getLocale(),
	country: onelps.config.getCountry(),
	isMonolingual: onelps.config.isMonolingual(),
	portalBarCSS: onelps.config.getPortalBarCss(),
	portalBarJS: onelps.config.getPortalBarJs(),
	portalBarHTML: onelps.config.getPortalBarHtml(),
	cdnUrlPrefix: onelps.config.getCdnAssetUrlPrefix(),
	landingPageId: onelps.config.getLandingPageId(),
	partnerPrefix: onelps.config.getPartnerPrefix(),
	campaignId: removeBackslashes(onelps.config.getCampaignId()),
	bannerId: removeBackslashes(onelps.config.getBannerId()),
	creativeId: removeBackslashes(onelps.config.getCreativeId()),
	publisherId: removeBackslashes(onelps.config.getPublisherId()),
	backendRequestEventId: onelps.config.getBackendRequestEventId(),
	nickname: 'RememberMeNickname',
	forgotPw: {
		'token': onelps.config.getPasswordForgottenToken(),
		'errorCode': onelps.config.getPasswordForgottenErrorCode(),
	},
	portalSsoError: {
		'type': onelps.config.getPortalSsoErrorType(),
		'translationKey': onelps.config.getPortalSsoErrorTranslationKey(),
	},
	ssoConfirmationPath: onelps.config.getSsoConfirmationPath(),
	singularPcn: removeBackslashes(onelps.config.getPcn()),
	singularDeepLink: onelps.config.getSingularDeepLink(),
	isSingularForwardParams: onelps.config.isSingularForwardParams(),
	operatingSystem: onelps.config.getOperatingSystem(),
	deviceType: onelps.config.getDeviceType(),
	isMobileRequest: onelps.config.isMobileRequest(),
	isBot: onelps.config.isBot(),
	isSpam: onelps.config.isSpam(),
	environment: onelps.config.getEnvironment(),
	lpsUrl: onelps.config.getLpsUrl(),
	otherGames: onelps.config.getOtherGames(),
	challengeConfig: onelps.config.getChallengeConfig(),
};

export const OneLPSsdkParamsContext = React.createContext(<SdkParams>sdkParams);
